import { API } from "aws-amplify";

const API_NAMES = {
  VITALICIAS: "api-vitalicias",
};

const API_PATHS = {
    MEJORA_RV: "/solicitud/cotizacion/rv/mejora",
    RECALCULO_RV: "/solicitud/cotizacion/rv/recalculo",
    LISTAR_RV: "/solicitud/listar",
    BENEFICIARIO_RV: "/solicitud/beneficiario",
    ASEGURADO_RV: "/solicitud/asegurado",
}

interface ImprovementData {
    id: any;
    indice: any;
    cuspp: any;
    tasaVenta: string;
    cesionComision: string;
    guardar: boolean;
}

interface RecalculateData {
    id: any;
    indice: any;
    cuspp: any;
    cic: string;
    guardar: boolean;
    fechaRecal1?: string;
    fechaRecal2?: string;
}

interface ImprovementRequest {
    payload: {
        data: {
            producto: {
                CodProducto: string;
                mejora: ImprovementData;
            }
        }
    }
}

interface RecalculateRequest {
    payload: {
        data: {
            producto: {
                CodProducto: string;
                recalculo: RecalculateData;
            }
        }
    }
}

export const sendImprovement = async (payload: ImprovementRequest, callBack: () => Promise<void>) => {
    const request = {
        body: payload,
        headers: {},
    }
    try {
        await API.post(API_NAMES.VITALICIAS, API_PATHS.MEJORA_RV, request);         
    } catch (error) {
        console.error("Error en sendImprovement:", error);
        await callBack();
    }
}

export const sendRecalculate = async (payload: RecalculateRequest) => {
    const request = {
        body: payload,
        headers: {},
    }
    try {
        const response = await API.post(API_NAMES.VITALICIAS, API_PATHS.RECALCULO_RV, request);
        return response;
    } catch (error) {
        console.error("Error en sendRecalculate:", error);
        throw error;
    }
}

export const getQuotesList = async (params: any) => {
    const requestParams = { ...params };
    requestParams.filter = requestParams.filterRV;
    delete requestParams["filterRV"];
    const requestBody = { payload: requestParams };

    try {
        const response = await API.post(API_NAMES.VITALICIAS, API_PATHS.LISTAR_RV, {
            body: requestBody,
        });
        return response;
    } catch (error) {
        console.error("Error en getQuotesList:", error);
        throw error;
    }
}

export const updateBeneficiary = async (data: any) => {
    const request = {
        body: { payload: data },
        headers: {},
    };
    try {
        const response = await API.patch(API_NAMES.VITALICIAS, API_PATHS.BENEFICIARIO_RV, request);
        return response;
    } catch (error) {
        console.error("Error en updateBeneficiary:", error);
        throw error;
    }
}

export const updateAssured = async (data: any) => {
    const request = {
        body: { payload: data },
        headers: {},
    };
    try {
        const response = await API.patch(API_NAMES.VITALICIAS, API_PATHS.ASEGURADO_RV, request);
        return response;
    } catch (error) {
        console.error("Error en updateAssured:", error);
        throw error;
    }
}